<template>
  <div class="p-8">
    <form @submit.prevent="add">
      <div class="flex pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            New FQA
          </h3>
          <p class="text-gray-600">Add a new fqa!</p>
        </div>
        <div class="w-2/3">
          <div class="flex space-x-4">
            <label class="block w-1/3">
              <span class="text-gray-700">question</span>
              <input
                v-model="question"
                class="form-input block w-full"
                placeholder="Question"
              />
            </label>
            <label class="block w-1/3">
              <span class="text-gray-700">answer</span>
              <input
                v-model="answer"
                class="form-input block w-full"
                placeholder="Answer"
              />
            </label>
            <div class="w-1/3">
              <select
                class="form-select w-full"
                v-model="type"
              >
                <option :selected="type === 'passenger'" value="passenger">
                  Passenger
                </option>
                <option :selected="type === 'driver'" value="driver">
                  Driver
                </option>
              </select>
            </div>
          </div>
          <div class="mt-4">
            <button
              :disabled="busy"
              class="w-32 py-2 text-ilift-900 rounded shadow"
              :class="
                busy
                  ? 'bg-ilift-200 cursor-not-allowed'
                  : 'bg-ilift-500 hover:bg-ilift-600'
              "
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busy: false,
      question: "",
      answer: "",
      type: "passenger"
    };
  },
  computed: {},
  methods: {
    add() {
      if (this.question && this.answer) {
        this.busy = true;
        this.$http
          .post("/fqa", {
            question: this.question,
            answer: this.answer,
            type: this.type
          })
          .then(() => {
            window.flash({
              body: "FQA added successfully!",
              type: "success"
            });
            this.$router.push("/fqa");
          })
          .catch(err => {
            console.log(err);
            window.flash({ body: "Failed to add FQA!", type: "error" });
          })
          .finally(() => (this.busy = false));
      }
    }
  }
};
</script>
